import ApiService from "@/common/api.service";
import {
  FETCH_VEHICLE_SPARE_PARTS,
  FETCH_VEHICLE_SPARE_PART_HISTORY
} from "./actions.type";
import {
  FETCH_VEHICLE_SPARE_PARTS_START,
  SET_VEHICLE_SPARE_PARTS,
  FETCH_VEHICLE_SPARE_PART_HISTORY_START,
  SET_VEHICLE_SPARE_PART_HISTORY
} from "./mutations.type";

const state = {
  vehicleSpareParts: [],
  vehicleSparePartsCount: 1,
  vehicleSparePartsIsLoading: false,
  vehicleSparePartHistory: [],
  vehicleSparePartHistoryIsLoading: false
};

const getters = {
  vehicleSpareParts: state => state.vehicleSpareParts,
  vehicleSparePartsCount: state => state.vehicleSparePartsCount,
  vehicleSparePartsIsLoading: state => state.vehicleSparePartsIsLoading,
  vehicleSparePartHistory: state => state.vehicleSparePartHistory,
  vehicleSparePartHistoryIsLoading: state =>
    state.vehicleSparePartHistoryIsLoading
};

const actions = {
  [FETCH_VEHICLE_SPARE_PARTS](
    { commit },
    [vehicleId, filteringCriteria, search, filters]
  ) {
    commit(FETCH_VEHICLE_SPARE_PARTS_START);
    return ApiService.filteredCollection(
      `vehicles/${vehicleId}/spare-parts`,
      filteringCriteria,
      search,
      filters
    ).then(({ data }) => {
      commit(SET_VEHICLE_SPARE_PARTS, data);
    });
  },
  [FETCH_VEHICLE_SPARE_PART_HISTORY](context, [vehicleId, sparePartId]) {
    context.commit(FETCH_VEHICLE_SPARE_PART_HISTORY_START);
    return ApiService.get(
      `/vehicles/${vehicleId}/spare-parts/${sparePartId}/history`
    ).then(({ data }) => {
      context.commit(SET_VEHICLE_SPARE_PART_HISTORY, data);
    });
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_VEHICLE_SPARE_PARTS_START](state) {
    state.vehicleSparePartsIsLoading = true;
  },
  [SET_VEHICLE_SPARE_PARTS](state, data) {
    state.vehicleSpareParts = data.items || [];
    state.vehicleSparePartsCount = data.total || 1;
    state.vehicleSparePartsIsLoading = false;
  },
  [FETCH_VEHICLE_SPARE_PART_HISTORY_START](state) {
    state.vehicleSparePartHistoryIsLoading = true;
  },
  [SET_VEHICLE_SPARE_PART_HISTORY](state, data) {
    state.vehicleSparePartHistory = data || [];
    state.vehicleSparePartHistoryIsLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
